import React from 'react';
import { SuspensionPage } from './components/SuspensionPage';
export function App() {
  return <SuspensionPage data-id="element-0" />;
}